import Vue from 'vue'
// import VueAMap from 'vue-amap'
import App from './App.vue'
import { router } from '@/router'
import store from './store/index'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/utils/validate.js'
// import 'amfe-flexible'
import 'assets/style/reset.css'
// import * as filters from './filters'
import fastclick from 'fastclick'
// import km from './plugins'
// 引入iconfont的css
import 'assets/iconfont/iconfont.css'
import 'assets/style/index.less'

import VueWechatTitle from 'vue-wechat-title'

// import VueLazyload from 'vue-lazyload'

// 注册全局组件
// import components from './components'
// 引入日志错误上报组件
// import '@/utils/monitor'
// Vue.use(components)

// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key: '2ac731ec05dc74b577cd973c52e7a92a',
//   plugin: ['AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.Autocomplete', 'AMap.CitySearch'],
//   // 默认高德 sdk 版本为 1.4.4
//   uiVersion: '1.0',
//   v: '1.4.4'
// })
// Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   error: require('./assets/images/fill.png'),
//   loading: require('./assets/images/fill.png')
// })
Vue.use(VueWechatTitle)
// Vue.use(km)
Vue.use(Vant)

// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })

fastclick.attach(document.body)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
